module.exports = __webpack_public_path__ + "img/(per 1000 live births) NDHS_2018.d554edec.png";